import { render } from "./SubAccountInvestmentsCard.vue?vue&type=template&id=47c878c6&scoped=true"
import script from "./SubAccountInvestmentsCard.vue?vue&type=script&lang=js"
export * from "./SubAccountInvestmentsCard.vue?vue&type=script&lang=js"

import "./SubAccountInvestmentsCard.vue?vue&type=style&index=0&id=47c878c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47c878c6"

export default script